import { defineQuartzConfig } from 'quartz-config';
export default defineQuartzConfig({
  type: 'application',
  auth: 'none',
  htmlTitle: 'Portals Base APP',
  htmlTitleLangKey: 'app.htmlTitle',
  historyBasename: '/:basename',
  createRootApi: true,
  loadWhisperCore: false,
  initialPageLoadTracking: false,
  icons: null,
  includeDefaultViewportMetaTag: true,
  otel: {
    dynamicSampleRate: false
    // sampleRate: 0.01,  // optional: pin your own rate
  }
});